export default {
    state: {
        all: [],
        filtered: [],
        selectedBuildingId: null,
        selectedBuilding: null
    },
	actions: {
		loadBuildings({ commit }, criteria) {
			axios.get('/api/buildings',	{
				params: {
    				criteria: criteria
  				}
  			}).takeAtLeast(300).then(buildings => {
				commit('setBuildings', buildings)
			}).catch(response => {
				console.error(response);
			});
		}
	},
	mutations: {
		setBuildings(state, buildings) {
			state.all = buildings.data
			state.filtered = buildings.data
		}
	},
	getters: {
		buildingsSortedBy: (state) => (fields) => {
			return _.sortBy(state.all, fields);
		}
	}
};